import { useTheme } from "@hooks/useTheme";

const PrimaryButton = ({
  children,
  onClick,
  className = "",
  disabled = false,
  type = "button",
  size = "md",
  icon: Icon,
  variant = "primary",
  ...props
}) => {
  const { colors } = useTheme();

  const sizeClasses = {
    sm: "h-8 px-4 py-1.5 text-xs",
    md: "h-9 px-5 py-2 text-sm",
    lg: "h-10 px-6 py-3 text-base",
  };

  const variantClasses = {
    primary: `${colors.buttonBackgroundGradient} ${colors.buttonBackgroundGradientHover}`,
    danger: `${colors.buttonDangerBackground} ${colors.buttonDangerBackgroundHover} ${colors.textPrimary}`,
  };

  const baseClasses =
    "min-w-[86px] font-600 inline-flex items-center justify-center rounded-md font-semibold shadow-sm transition-colors whitespace-nowrap focus:outline-none";

  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed hover:opacity-50"
    : "hover:opacity-90";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${disabledClasses} ${className}`}
      {...props}
    >
      {Icon && <Icon className="mr-2 h-4 w-4 sm:hidden" />}
      <span className="hidden sm:inline">{children}</span>
      <span className="sm:hidden">{children}</span>
    </button>
  );
};

export default PrimaryButton;